import React, { useId } from 'react';
import { UncontrolledTooltip } from 'reactstrap';

import FilterIcon from '../../assets/icons/top-bar-icons/filter.svg?react';
import FilterCheckIcon from '../../assets/icons/top-bar-icons/filter-check.svg?react';
import RefreshIcon from '../../assets/icons/top-bar-icons/refresh.svg?react';

import './toolbar-button.scss';

const buttonIconMap = {
  'lf-icon-filter': FilterIcon,
  'lf-icon-filter-1': FilterIcon,
  'lf-icon-filter-applied': FilterCheckIcon,
  'lf-icon-refresh': RefreshIcon
};

const getButtonIcon = (iconParam, className = '', style = {}) => {
  if (!iconParam || typeof iconParam !== 'string') {
    return iconParam || '';
  }

  if (iconParam.includes('lf-icon')) {
    const iconClasses = iconParam.split(' ');
    const specificIconClass = iconClasses.find(
      cls => cls.startsWith('lf-icon-') && cls !== 'lf-icon'
    );

    if (specificIconClass && buttonIconMap[specificIconClass]) {
      const IconComponent = buttonIconMap[specificIconClass];
      return (
        <IconComponent className={className} style={style} aria-hidden="true" />
      );
    }
    if (buttonIconMap[iconParam]) {
      const IconComponent = buttonIconMap[iconParam];
      return (
        <IconComponent className={className} style={style} aria-hidden="true" />
      );
    }
    return iconParam;
  }
  if (iconParam && buttonIconMap[`lf-icon-${iconParam}`]) {
    const IconComponent = buttonIconMap[`lf-icon-${iconParam}`];
    return (
      <IconComponent className={className} style={style} aria-hidden="true" />
    );
  }
  return iconParam || '';
};

const ToolBarButton = ({
  onClick,
  disabled = false,
  icon,
  title = '',
  className,
  bordered = false,
  ref
}) => {
  const resolvedIcon = getButtonIcon(icon);
  const tooltipId = `toolbar-button-${useId().replace(/:/g, '')}`;

  return (
    <>
      <button
        ref={ref}
        onClick={onClick}
        disabled={disabled}
        className={`${'btn-toolbar'} ${className || ''} ${
          disabled && 'btn-toolbar-disabled'
        } ${bordered && 'btn-toolbar-bordered'}`}
        id={tooltipId}
      >
        {resolvedIcon &&
          (React.isValidElement(resolvedIcon) ? (
            resolvedIcon
          ) : (
            <i className={resolvedIcon} />
          ))}
      </button>
      {title && (
        <UncontrolledTooltip
          target={tooltipId}
          placement="bottom"
          popperClassName="lf-tooltip"
        >
          {title}
        </UncontrolledTooltip>
      )}
    </>
  );
};

export default ToolBarButton;
